
import { IHypercortisolaemiaCabergoline } from './HypercortisolaemiaCabergoline.types';

export const initialHypercortisolaemiaCabergoline : IHypercortisolaemiaCabergoline= {
  dose: "",
  dateStart: null,
  dateEnd: null,
  dateEndIsActive: false
}